import script from "./BurgerMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&setup=true&lang=js"

import "./BurgerMenu.vue?vue&type=style&index=0&id=33200708&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33200708"]])

export default __exports__